<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
            
        </base-header>

        <div class="container-fluid mt--9" style="margin-top:-9">
            <div class="row">
                <div class="col-xl-12 mb-5 mb-xl-0">
                  
                </div>

            </div>
            <!-- End charts-->

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <conciliaciones></conciliaciones>
                </div>
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
  // Charts
  import axios from 'axios'

  // Tables
  import Conciliaciones from '../components/Conciliaciones/ConciliacionesList';

  export default {
    components: {
      Conciliaciones
    },
    data() {
      return {
        invoices: []
      };
    },
    methods: {

    },
    mounted() {

    },
    created(){
      axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
    }
  };
</script>
<style></style>
